import { render, staticRenderFns } from "./SuggestAnalysisSamplesOutputContainer.vue?vue&type=template&id=a4f42f30&scoped=true"
import script from "./SuggestAnalysisSamplesOutputContainer.vue?vue&type=script&lang=js"
export * from "./SuggestAnalysisSamplesOutputContainer.vue?vue&type=script&lang=js"
import style0 from "./SuggestAnalysisSamplesOutputContainer.vue?vue&type=style&index=0&id=a4f42f30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4f42f30",
  null
  
)

export default component.exports